import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { formatDate } from 'lib/util';
import { formatMoney, formatNumber } from 'accounting-js';

export default class DisabledReportRow extends PureComponent {
  static propTypes = {
    asset: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      number: PropTypes.string.isRequired,
    }).isRequired,
    depreciation: PropTypes.oneOf(['fiscal', 'financial']).isRequired,
  };

  depreciation = () => {
    switch (this.props.depreciation) {
      case 'fiscal':
        return this.props.asset._fiscalDepreciationResult || {};
      case 'financial':
        return this.props.asset._financialDepreciationResult || {};
      default:
        return {};
    }
  };

  hasError = () => {
    switch (this.props.depreciation) {
      case 'fiscal':
        return (
          !this.props.asset._fiscalDepreciationResult ||
          !this.props.asset._fiscalDepreciationResult.name
        );
      case 'financial':
        return (
          !this.props.asset._financialDepreciationResult ||
          !this.props.asset._financialDepreciationResult.name
        );
      default:
        return true;
    }
  };

  hasWarning = () => {
    const depreciation = this.depreciation();
    return depreciation.factors && depreciation.factors.warning;
  };

  render = () => {
    const { asset } = this.props;
    const depreciation = this.depreciation();
    return (
      <tr
        className={classnames({
          'table-warning': this.hasWarning(),
          'table-danger': this.hasError(),
        })}
      >
        <td className="align-middle">{asset.number}</td>
        <td className="align-middle">{asset.name}</td>
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset._costCenter
            ? `${this.props.asset._costCenter.key} - ${this.props.asset._costCenter.name}`
            : ''}
        </td>
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset._account
            ? `${this.props.asset._account.key} - ${this.props.asset._account.name}`
            : ''}
        </td>

        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset._subaccount
            ? `${this.props.asset._subaccount.key} - ${this.props.asset._subaccount.name}`
            : ''}
        </td>
        <td className="align-middle">{asset.disableDetail}</td>
        <td className="align-middle">{formatDate(asset.buyDate)}</td>
        <td className="align-middle">{depreciation.name}</td>
        <td className="align-middle">{asset.startDate ? formatDate(asset.startDate) : ''}</td>
        <td className="align-middle">{asset.disableDate ? formatDate(asset.disableDate) : ''}</td>
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(asset.price || 0)}
        </td>
        <td className="text-center align-middle">
          {formatNumber(parseFloat(depreciation.years) || 0, { precision: 4 })}
        </td>
        <td className="text-right align-middle align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(depreciation.originalAmount || 0)}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(depreciation.factors ? depreciation.factors.inpcBegin : 0, {
            precision: 4,
          })}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(depreciation.factors ? depreciation.factors.inpcEnd : 0, { precision: 4 })}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(depreciation.factors ? depreciation.factors.factor : 0, { precision: 4 })}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(depreciation.totalDepreciation || 0)}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(depreciation.depreciable || 0)}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(asset.disableAmount || 0)}
        </td>
        <td
          className={classnames('text-right align-middle', {
            'table-warning': depreciation.refound < 0,
            'table-info': depreciation.refound === 0,
            'table-success': depreciation.refound > 0,
          })}
          style={{ whiteSpace: 'nowrap' }}
        >
          {formatMoney(depreciation.refound || 0)}
        </td>
      </tr>
    );
  };
}



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/disabled/DisabledReportRow.js